<template>
  <section>
    <person
      v-for="person in people"
      :key="person.rosters_id"
      class="mb-3"
      :person-id="person.rosters_id"
      :person="person"
      :can-manage="canManage || person.canManage"
      :can-view-birthday-and-anniversary="canManage || person.canViewBirthdayAndAnniversary"
      :show-staff-phone="showStaffPhone"
      :onboarding-progress="person.onboardingProgress"
      :onboarding-project-url="person.onboardingProjectUrl"
      @showImages="showImages(person.rosters_id)"
    ></person>
    <user-images
      v-model="userPhotosVisible"
      :can-manage="canManage || canManageAny"
      :user-id="userImagesId"
    >
    </user-images>
  </section>
</template>

<script>
import Person from './Person'
import UserImages from '@/components/UserImages'
import { filter } from 'lodash'

export default {
  components: {
    Person,
    UserImages
  },
  props: {
    people: {
      type: Array,
      required: true
    },
    canManage: {
      type: Boolean,
      default: false
    },
    showStaffPhone: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    canManageAny() {
      return filter(this.people, (person) => {
        return person.canManage
      }).length > 0
    }
  },
  data () {
    return {
      userPhotosVisible: false,
      userImagesId: null
    }
  },
  methods: {
    showImages (userId) {
      this.userImagesId = userId
      this.userPhotosVisible = true
    }
  }
}
</script>